import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Spacing } from 'components/ui';
import { CatalogFormFieldEntity } from 'entities/CatalogFormField';
import { useWindowDimensions } from 'hooks/';
import { FieldsCatalogControllerStore } from 'stores/local/forms/EditFormStore/FieldsCatalogControllerStore';

import { OneColumn } from './OneColumn';
import { COLUMN_WIDTH } from './config';
import { FieldsColumn, spreadFieldsInColumns } from './utils';

type Props = {
  showOnlySelected: boolean;
  catalogDrawerControllerStore: FieldsCatalogControllerStore;
  fields: Record<string, CatalogFormFieldEntity[]>;
  showGroupTitles?: boolean;
};

const FieldColumns: React.FC<Props> = ({
  showOnlySelected,
  showGroupTitles,
  catalogDrawerControllerStore,
  fields,
}: Props) => {
  const { width } = useWindowDimensions();

  const columnsCount = Math.floor(width / COLUMN_WIDTH);

  const allColumnsChunks: FieldsColumn[] = React.useMemo(() => {
    return spreadFieldsInColumns({
      fields,
      columnsCount,
      showOnlySelected,
      isFieldSelected: (id) => catalogDrawerControllerStore.isFieldSelected(id),
    });
  }, [fields, columnsCount, showOnlySelected, catalogDrawerControllerStore]);

  return (
    <Spacing>
      <Spacing.Row>
        {allColumnsChunks.map((columnChunks, columnIndex) => (
          <Spacing.RowItem grow key={columnIndex}>
            <OneColumn
              fieldsColumn={columnChunks}
              catalogDrawerControllerStore={catalogDrawerControllerStore}
              showGroupTitles={showGroupTitles}
            />
          </Spacing.RowItem>
        ))}
      </Spacing.Row>
    </Spacing>
  );
};

export default observer(FieldColumns);
